import React, { useEffect, useCallback, useState } from "react";
import { Formik, Form, Field } from "formik";
import { PerformanceNavbar } from "./reusedcomponent/navbar";
import { ApiService } from "../../../services/ApiService";
import { performanceMngtThunk } from "../../../store/actions/performancemanagement/performance.thunk";
import { useDispatch, useSelector } from "react-redux";
import { employeeMngtThunk } from "../../../store/actions/employeemanagement/employee.thunk";
import moment from "moment";
import { Link } from "react-router-dom";
import useModal from "../../../utils/useModal";
import Modal from "react-modal";
import ReviewDetails from "./modals/reviewForm";
import { useAlert } from "react-alert";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    // border: "2px solid green",
  },
};

Modal.setAppElement("#root");

export const PerformanceIndex = () => {
  const alert = useAlert();
  const { modalIsOpen, openModal, closeModal } = useModal();
  const { events, performanceReview, employeeAppraisal } = useSelector(
    (state) => state.performanceMngt
  );
  const [employee, setEmployee] = useState({});
  const [SelectedEmployees, setSelectedEmplyees] = useState([]);
  const { employees } = useSelector((state) => state.employeeMngt);
  const dispatch = useDispatch();

  console.log("events", events);
  console.log("perrr", performanceReview);
  console.log("apparaisal", employeeAppraisal);

  const getEmployeeReview = useCallback(async () => {
    await dispatch(performanceMngtThunk.getEvents());
    await dispatch(performanceMngtThunk.getEmployeeAppraisal());
    await dispatch(performanceMngtThunk.getPerformanceReview());
    await dispatch(employeeMngtThunk.getEmployeesDetails());
  }, [dispatch]);

  useEffect(() => {
    getEmployeeReview();
  }, []);

  return (
    <React.Fragment>
      <PerformanceNavbar />
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="create event modal"
      >
        <ReviewDetails
          closeModal={closeModal}
          // employee={user}
          alert={alert}
          id={employee}
        />
      </Modal>
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="m-t-30 m-b-30">
                <div className="row">
                  {/* COMMENTED WAS ON PURPOSE    */}
                  {events.is_active === 1 ? (
                    <React.Fragment>
                      <Formik
                        initialValues={{
                          employees: [],
                          category: events.event_category.id,
                          start_date: events.start_date,
                          end_date: events.end_date,
                        }}
                        onSubmit={async (values, { setSubmitting }) => {
                          const employeess = [];
                          values.employees.map((id) =>
                            employeess.push({ employee_id: Number(id) })
                          );
                          values.employees = employeess;
                          ApiService.post(
                            "events/select-employee-to-appraise-me",
                            values
                          ).then((res) => {
                            if (res.data.type === false) {
                              setSubmitting(false);
                              alert.error(res.data.msg);
                            } else if (res.data.type === true) {
                              alert.success(res.data.msg);
                              history.push("/dashboard/performance");
                            }
                          });
                          console.log(values);
                        }}
                      >
                        {({
                          isSubmitting,
                          values,
                          handleChange,
                          setFieldValue,
                        }) => (
                          <Form>
                            <div className="col-md-6 performance-review-wrapper">
                              <div className="text-center">
                                <h4 className="text-dark">
                                  {" "}
                                  Select Employees to Appraise you{" "}
                                </h4>
                              </div>
                              <div className="text-center">
                                <p>
                                  {" "}
                                  Expect reviews from your appraisers soon{" "}
                                </p>
                              </div>

                              <div className="text-center">
                                <p>
                                  Appraisal(s) has been submitted.{" "}
                                  <Link to="/dashboard/performance">
                                    Click here to view it
                                  </Link>{" "}
                                </p>
                              </div>
                              <table
                                className="table table-bordered employees-review-table"
                                id=""
                              >
                                <thead>
                                  <tr>
                                    <th className="th-sm">NO</th>
                                    <th className="th-sm">SELECT</th>
                                    <th className="th-sm">NAME</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {employees.map((employee, i) => (
                                    <tr key={i}>
                                      <td>{i + 1}</td>
                                      <td>
                                        <input
                                          type="checkbox"
                                          name="employees"
                                          id="employees"
                                          className="employee_review_check"
                                          checked={
                                            values.employees !== undefined &&
                                            values.employees.includes(
                                              employee.id.toString()
                                            )
                                              ? true
                                              : false
                                          }
                                          value={employee.id.toString()}
                                          onChange={handleChange}
                                          disabled={
                                            values.employees &&
                                            values.employees.length === 3
                                              ? true
                                              : false
                                          }
                                        />
                                      </td>
                                      <td>
                                        {employee.first_name.toUpperCase()}{" "}
                                        {employee.last_name.toUpperCase()}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                              <div>
                                <button
                                  className="btn nt-button-color-default"
                                  id="select_emp_for_review_btn"
                                >
                                  Proceed{" "}
                                  {isSubmitting ? (
                                    <span
                                      id="login_spinner"
                                      className="fa fa-spin fa-spinner"
                                    ></span>
                                  ) : null}
                                </button>
                                {/* <button
                                  className="btn nt-button-color-default"
                                  id="select_emp_for_review_btn"
                                >
                                  <span
                                    className="fa fa-spin fa-spinner"
                                    id="select_emp_for_review_spinner"
                                  ></span>{" "}
                                  &nbsp; &nbsp;Proceed
                                </button> */}
                              </div>
                            </div>
                          </Form>
                        )}
                      </Formik>

                      <div className="col-md-6 performance-review-wrapper">
                        <div className="text-center">
                          <h4 className="text-dark">
                            Employees that you need to appraise
                          </h4>
                        </div>

                        <div className="text-center">
                          <p>
                            You are yet to be selected by any employee as an
                            appraiser{" "}
                          </p>
                        </div>

                        <table className="table table-bordered start-appraisal-table">
                          <thead>
                            <tr>
                              <th className="th-sm">NO</th>
                              <th className="th-sm">NAME</th>
                              <th className="th-sm">ACTION</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>ttt</td>
                              <td>rrrr</td>
                              <td>
                                <button
                                  onClick={() => {
                                    const value = { id: employee.id };
                                    setEmployee(value);
                                    openModal();
                                  }}
                                  className="btn btn-block nt-button-color-default"
                                >
                                  Start Appraisal
                                </button>

                                <button
                                  className="btn btn-block nt-button-color-default"
                                  id=""
                                >
                                  Appraised
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </React.Fragment>
                  ) : (
                    <div className="col-md-6 offset-md-3">
                      <div className="card p-5 ">
                        <div className="col-md-12">
                          <h4 className="text-dark">
                            Performance Review For This Quarter
                          </h4>
                        </div>
                        <input type="hidden" />
                        <div className="form-group">
                          <label for="category">Category</label>
                          <input
                            type="text"
                            className="form-control item"
                            name="category"
                            id="category"
                            disabled
                            value={
                              events.event_category &&
                              events.event_category.name
                            }
                          />
                        </div>
                        <div className="form-group">
                          <label for="event_name">Event Name</label>
                          <input
                            type="text"
                            className="form-control item"
                            name="event_name"
                            id="event_name"
                            disabled
                            value={events.name}
                          />
                        </div>

                        <div className="form-group">
                          <label for="event_start_date">Start Date</label>
                          <input
                            type="text"
                            className="form-control datedrop item"
                            name="event_start_date"
                            id="event_start_date"
                            autocomplete="off"
                            value={events.start_date}
                            disabled
                          />
                        </div>

                        <div className="form-group">
                          <label for="event_end_date">End Date</label>
                          <input
                            type="text"
                            className="form-control item"
                            name="event_end_date"
                            id="event_end_date"
                            autocomplete="off"
                            value={events.end_date}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  {/* COMMENTED WAS ON PURPOSE    */}

                  {/* <div className="col-md-6 offset-md-3">
                                                <div>
                                                    <h4 className="text-center" >No active performance review </h4>
                                                </div>
                                                <table className="table table-bordered start-appraisal-table">
                                                    <thead>
                                                    <tr>
                                                        <th className="th-sm"></th>
                                                        <th className="th-sm">PERFORMANCE REVIEW</th>
                                                        <th className="th-sm">STATUS</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody id="job_title">
                                                
                                                        <tr>
                                                            <td>erere</td>
                                                            <td>4455</td>
                                                            <td>
                                                                <button className="btn btn-block nt-button-color-default" id=""> ttt</button>
                                                            </td>
                                                        </tr>
                                                    
                                                    </tbody>
                                                </table>
                                            </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/perfomancemanagement/index.js